import { createCustomEnum } from "../customEnum";

const ReviewTypeEnum = createCustomEnum({
	Initial: {
		value: 0,
		name: "initial",
		displayName: "Initial Review",
	},
	FollowUp: {
		value: 1,
		name: "follow_up",
		displayName: "Follow Up",
	},
});
export default ReviewTypeEnum;
